import React, { Suspense, useEffect, useState } from 'react'
import Sidebar from '../../Components/Sidebar/Sidebar'
import './Homepage.scss'
import { lazy } from 'react';
import Loading from '../../Components/Loading/Loading';
import { Link } from 'react-router-dom';
import BilingualText from '../../Components/BilingualText/BilingualText';
import { SiBookstack } from 'react-icons/si';
import { MdQuiz, MdOndemandVideo, MdAutoStories } from 'react-icons/md';

const AlphabetsLazy = lazy(() => import('../../Components/Alphabets/Alphabets'));
const isDesktopViewport = () => typeof window !== 'undefined' && window.innerWidth >= 1280;

const quickLinks = [
    {
        to: '/books',
        icon: SiBookstack,
        primary: 'Read Books',
        secondary: 'ਕਿਤਾਬਾਂ ਪੜ੍ਹੋ'
    },
    {
        to: '/quiz',
        icon: MdQuiz,
        primary: 'Play Quiz',
        secondary: 'ਕਵਿਜ਼ ਖੇਡੋ'
    },
    {
        to: '/stories',
        icon: MdAutoStories,
        primary: 'Explore Stories',
        secondary: 'ਕਹਾਣੀਆਂ ਦੇਖੋ'
    },
    {
        to: '/videos',
        icon: MdOndemandVideo,
        primary: 'Watch Videos',
        secondary: 'ਵੀਡੀਓ ਦੇਖੋ'
    }
]

const learningPillars = ['Audio', 'Stories', 'Worksheets', 'Quizzes']

const Homepage = ({ Helmet }) => {
    const [isDesktopLayout, setIsDesktopLayout] = useState(isDesktopViewport)

    const [showLeftSidebar, setShowLeftSidebar] = useState(true)
    const [showRightSidebar, setShowRightSidebar] = useState(true)

    useEffect(() => {
        const handleResize = () => {
            setIsDesktopLayout(isDesktopViewport())
        }

        handleResize()
        window.addEventListener('resize', handleResize)

        return () => window.removeEventListener('resize', handleResize)
    }, [])


    const showSidebar = (sidebarInfo) => {
        if (sidebarInfo === "Left Sidebar"){
            setShowLeftSidebar(!showLeftSidebar)
        }if (sidebarInfo === "Right Sidebar"){
            setShowRightSidebar(!showRightSidebar)
        }
    }


  return (
        <div className={`homepage_Container${!isDesktopLayout ? ' homepage_Container--mobile' : ''}`}>
              {Helmet && (
                <Helmet>
                  <title>Punjabi Academy — Learn Punjabi Online for Free</title>
                  <meta name="description" content="Punjabi Academy is a free educational website for children and beginners to learn Punjabi — alphabets, stories, quizzes, videos and worksheets." />
                </Helmet>
              )}
        {isDesktopLayout ? (
          <section className='leftSidebar_Container'>
              <Sidebar title={"Left Sidebar"} functionClick={showSidebar} showLeftSidebar={showLeftSidebar} />
              <div className='homepage_SideImage'>
                  <img src="https://punjabikidz.com/home/wp-content/uploads/2024/11/Punjabikidz-1.webp" alt='Children learning Punjabi' loading='lazy' />
                  <div className='homepage_SideImageCaption'>
                      <span>ਪੰਜਾਬੀ ਸਿੱਖੋ</span>
                      <span>Learn Together</span>
                  </div>
              </div>
              <Sidebar title={"Right Sidebar"} functionClick={showSidebar} showRightSidebar={showRightSidebar} />
              <div className='homepage_SideImage'>
                  <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTY5N--o_2KtFkyKsmRHgckbkFvEQNjzKAzbw&s" alt='Punjabi alphabet practice sheet' loading='lazy' />
                  <div className='homepage_SideImageCaption'>
                      <span>ਅੱਖਰ ਲਿਖੋ</span>
                      <span>Write &amp; Learn</span>
                  </div>
              </div>
              <div className='homepage_SideImage'>
                  <img src="https://www.sikhschoolofla.com/assets/slider2-xjr_-ohE.png"alt='Punjabi alphabets colourful chart' loading='lazy' />
                  <div className='homepage_SideImageCaption'>
                      <span>ਅੱਖਰਮਾਲਾ</span>
                      <span>Alphabet Chart</span>
                  </div>
              </div>
              <div className='homepage_SideImage'>
                  <img src="https://www.sikhschoolofla.com/assets/slider4-1VMQrlgO.png" alt='All Punjabi alphabets' loading='lazy' />
                  <div className='homepage_SideImageCaption'>
                      <span>ਸਾਰੇ ਅੱਖਰ</span>
                      <span>All Letters</span>
                  </div>
              </div>
              <div className='homepage_SideImage'>
                  <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRuvEGcjObIjRNxjpX8vKbhdJ4snx-3giR5WA&s" alt='Parts of the body in Punjabi' loading='lazy' />
                  <div className='homepage_SideImageCaption'>
                      <span>ਸਰੀਰ ਦੇ ਅੰਗ</span>
                      <span>Parts of Body</span>
                  </div>
              </div>
          </section>
        ) : null}
        <section className='middle_Container'>
            <section className='homepage_Hero'>
                <div className='homepage_HeroContent'>
                    <p className='homepage_Eyebrow'>Punjabi Learning Hub</p>
                    <h1 className='homepage_HeroTitle'>Learn Punjabi</h1>
                    <p className='homepage_HeroSubtitle'>ਪੰਜਾਬੀ ਸਿੱਖੋ</p>
                    <p className='homepage_Intro'>
                        Start with alphabet sounds, then jump into stories, videos, quizzes, and books whenever you want a different way to learn.
                    </p>
                    <div className='homepage_Pillars' aria-label='Learning features'>
                        {learningPillars.map((pillar) => (
                            <span className='homepage_Pillar' key={pillar}>{pillar}</span>
                        ))}
                    </div>
                    <div className='homepage_QuickLinks'>
                        {quickLinks.map(({ to, icon: Icon, primary, secondary }) => (
                            <Link to={to} key={to} className='homepage_QuickLink'>
                                <span className='homepage_QuickLinkIcon' aria-hidden='true'>
                                    <Icon />
                                </span>
                                <span className='homepage_QuickLinkText'>
                                    <BilingualText primary={primary} secondary={secondary} />
                                </span>
                                <span className='homepage_QuickLinkArrow' aria-hidden='true'>→</span>
                            </Link>
                        ))}
                    </div>
                </div>
                <div className='homepage_HeroHighlights'>
                    <p className='homepage_HighlightLabel'>Why families like it</p>
                    <div className='homepage_HighlightCard'>
                        <strong>Interactive audio</strong>
                        <span>Tap cards to hear Punjabi sounds and words.</span>
                    </div>
                    <div className='homepage_HighlightCard'>
                        <strong>Bilingual practice</strong>
                        <span>Switch naturally between English and Punjabi labels.</span>
                    </div>
                    <div className='homepage_HighlightCard'>
                        <strong>Kid-friendly formats</strong>
                        <span>Use videos, stories, books, and quizzes together.</span>
                    </div>
                </div>
            </section>
            <div className='homepage_SectionIntro'>
                <p className='homepage_SectionEyebrow'>Start with sounds</p>
                <h2>Tap a card below to hear each letter and word</h2>
            </div>
            <Suspense fallback={<Loading/>}>
                <AlphabetsLazy/>
            </Suspense>
        </section>
    </div>
  )
}

// const HomeInfo = () => {
//     return (
//         <>
//         HomeInfo
//         </>
//     )
// }

export default Homepage
